import { render, staticRenderFns } from "./DocumentoListagemBotoesAcoes.vue?vue&type=template&id=c93895be&scoped=true"
import script from "./DocumentoListagemBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./DocumentoListagemBotoesAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93895be",
  null
  
)

export default component.exports